import TestSelectors from '@racemap/utilities/consts/test_selectors';
import type { RacemapEvent } from '@racemap/utilities/types/events';
import { Button, Flex, Result } from 'antd';
import type { Immutable } from 'immer';
import type { FC } from 'react';
import { checkLeaderboardActivationState } from 'src/components/Leaderboard/utils';

export const LeaderboardErrorPage: FC<{
  event: Immutable<RacemapEvent> | undefined | null;
  loadError?: { status: number | null } | null;
}> = ({ event, loadError }) => {
  // A failed event load (e.g. draft/archived event read by an anonymous user, or a
  // missing event) means no event data is available, so render based on the HTTP
  // status instead of the event state.
  if (loadError != null) {
    if (loadError.status === 404) {
      return (
        <Flex
          align="center"
          justify="center"
          vertical
          style={{ height: '100%' }}
          className={TestSelectors.leaderboard.errorPage.container.toString()}
          id={TestSelectors.leaderboard.errorPage.notFoundResult.toString()}
        >
          <Result
            status={404}
            title="Leaderboard not found!"
            extra={
              <Button type="primary" href="https://racemap.com">
                Back Home
              </Button>
            }
          />
        </Flex>
      );
    }

    if (loadError.status === 403) {
      return (
        <Flex
          align="center"
          justify="center"
          vertical
          style={{ height: '100%' }}
          className={TestSelectors.leaderboard.errorPage.container.toString()}
          id={TestSelectors.leaderboard.errorPage.forbiddenResult.toString()}
        >
          <Result
            status={403}
            title="This leaderboard is not available!"
            extra={
              <Button type="primary" href="https://racemap.com">
                Back Home
              </Button>
            }
          />
        </Flex>
      );
    }

    return (
      <Flex
        align="center"
        justify="center"
        vertical
        style={{ height: '100%' }}
        className={TestSelectors.leaderboard.errorPage.container.toString()}
        id={TestSelectors.leaderboard.errorPage.genericResult.toString()}
      >
        <Result
          status="error"
          title="Something went wrong loading the leaderboard."
          extra={
            <Button type="primary" href="https://racemap.com">
              Back Home
            </Button>
          }
        />
      </Flex>
    );
  }

  if (!event) return null;
  const { isArchived, isModuleActivated } = checkLeaderboardActivationState(event);

  if (isArchived) {
    return (
      <Flex
        align="center"
        justify="center"
        vertical
        style={{ height: '100%' }}
        className={TestSelectors.leaderboard.errorPage.container.toString()}
        id={TestSelectors.leaderboard.errorPage.archivedResult.toString()}
      >
        <Result
          status={403}
          title="Leaderboard is archived!"
          extra={
            <Button type="primary" href="https://racemap.com">
              Back Home
            </Button>
          }
        />
      </Flex>
    );
  }

  if (!isModuleActivated) {
    return (
      <Flex
        align="center"
        justify="center"
        vertical
        style={{ height: '100%' }}
        className={TestSelectors.leaderboard.errorPage.container.toString()}
        id={TestSelectors.leaderboard.errorPage.notActivatedResult.toString()}
      >
        <Result
          status={403}
          title="Leaderboard module is not activated!"
          extra={
            <Button type="primary" href="https://racemap.com">
              Back Home
            </Button>
          }
        />
      </Flex>
    );
  }

  return null;
};
